import React from 'react';
import { FaPencil } from 'react-icons/fa6';
import './editRoomButton.css';

// Pencil icon button used for launching the edit booking modal.
// The click handler prevents propagation so parent click events (such as
// cancelling a booking) are not inadvertently triggered.
export default function EditRoomButton({ onClick }) {
  const handleClick = (e) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <div className='editRoomButton' onClick={handleClick}>
      <FaPencil />
    </div>
  );
}
